/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow': {
    width: 10,
    height: 8,
    viewBox: '0 0 10 8',
    data: '<path pid="0" d="M0 6.524a.577.577 0 0 1 .115-.363L4.73.155a.343.343 0 0 1 .266-.148c.102 0 .2.053.272.148L9.885 6.16c.15.19.154.502.008.697a.343.343 0 0 1-.274.15H.386c-.21.004-.382-.212-.386-.484z" _fill="#000" fill-rule="evenodd"/>'
  }
})
